/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Commission_TaxInputs */

const es_ab_commission_tax = /** @type {(inputs: Ab_Commission_TaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` + IVA`)
};

const gl_ab_commission_tax = /** @type {(inputs: Ab_Commission_TaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` + IVE`)
};

const en_ab_commission_tax = /** @type {(inputs: Ab_Commission_TaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` + VAT`)
};

/**
* | output |
* | --- |
* | "+ VAT" |
*
* @param {Ab_Commission_TaxInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_commission_tax = /** @type {((inputs?: Ab_Commission_TaxInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Commission_TaxInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_commission_tax(inputs)
	if (locale === "en") return en_ab_commission_tax(inputs)
	return es_ab_commission_tax(inputs)
});